import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type ManageListProps = ComponentProps<"div"> & {
  variant?: "members" | "results"
}

function ManageList(props: ManageListProps) {
  const { variant = "members", className, ...divProps } = props
  return (
    <div
      className={cn(
        variant === "members" ? "manage-list-members" : "manage-list-results",
        className,
      )}
      {...divProps}
    />
  )
}

export default ManageList
